import React, { useEffect, useState, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button, Modal, Table, Spinner, Card, Container, Row, Col, Form, FormLabel, Accordion, InputGroup } from 'react-bootstrap';
import { DataManager } from '../../../core/data-manager';
import Select from 'react-select';
import { faCommentDollar } from '@fortawesome/free-solid-svg-icons';
import { ViewManager } from '../../../core/view-manager';
import { Utils } from '../../../core/utils';



export default function MPTH_item_model({ entity, data, searchObj, setSearchObj }) {

    const navigate = useNavigate();
    const searchableFields = Utils.cloneObject(ViewManager.getSearchableColumns(entity));

    const brandRef = useRef(null);
    const familyRef = useRef(null);
    const groupRef = useRef(null);
    const attributesRef = useRef(null);
    const attributes2Ref = useRef(null);

    const [codeItem, setCodeItem] = useState("");
    const [nameItem, setNameItem] = useState("");
    const [attributesList, setAttributesList] = useState([]);
    const [attributesList2, setAttributesList2] = useState([]);
    const [attributes, setAttributes] = useState([]);
    const [attributes2, setAttributes2] = useState([]);
    const [brandList, setBrandList] = useState([]);
    const [brand, setBrand] = useState([]);
    const [familyList, setFamilyList] = useState([]);
    const [family, setFamily] = useState([]);
    const [groupList, setGroupList] = useState([]);
    const [group, setGroup] = useState([]);
    const [lunghezza, setLunghezza] = useState("");
    const [altezza, setAltezza] = useState("");
    const [profondità, setProfondità] = useState("");

    const colourStyles = {
        option: (styles, { data, isDisabled, isFocused, isSelected }) => {
            const color = "#1C3550";
            return {
                ...styles,
                backgroundColor: isSelected
                    ? color
                    : isFocused
                        ? "#1c35504d"
                        : undefined,
                color: isSelected
                    ? "white"
                    : "black",
                ':active': {
                    ...styles[':active'],
                    backgroundColor: isSelected
                        ? color
                        : "#1c35504d"

                },
            };
        }
    };

    useEffect(() => {
        getBrand();
        getFamily();
        getGroup();
        getAttributes();
        getAttributes2();
    }, []);


    async function getBrand() {
        var sorting = {
            'field': 'name',
            'order': 'asc'
        }
        var res = await DataManager.getItems('brand', 1, 500, sorting);
        if (res.success === 1) {
            const temp = res.body.map(item => ({ value: item.id, label: item.name }));
            setBrandList(temp)
        }
    }
    async function getGroup() {
        var sorting = {
            'field': 'name',
            'order': 'asc'
        }
        var res = await DataManager.getItems('item_model_sales_group', 1, 500, sorting);
        if (res.success === 1) {
            const temp = res.body.map(item => ({ value: item.id, label: item.name }));
            setGroupList(temp)
        }
    }
    async function getFamily() {
        var sorting = {
            'field': 'name',
            'order': 'asc'
        }
        var res = await DataManager.getItems('item_model_family', 1, 500, sorting);
        if (res.success === 1) {
            const temp = res.body.map(item => ({ value: item.id, label: item.name }));
            setFamilyList(temp)
        }
    }
    async function getAttributes() {
        var sorting = {
            'field': 'name',
            'order': 'asc'
        }
        var res = await DataManager.getItems('attributes', 1, 500, sorting);
        if (res.success === 1) {
            const temp = res.body.map(item => ({ value: item.id, label: item.name }));
            setAttributesList(temp)
        }
    }
    async function getAttributes2() {
        var sorting = {
            'field': 'name',
            'order': 'asc'
        }
        var res = await DataManager.getItems('attributes', 1, 500, sorting);
        if (res.success === 1) {
            const temp = res.body.map(item => ({ value: item.id, label: item.name }));
            setAttributesList2(temp)
        }
    }

    //----------------------------------------------------------------------

    function handleBrand(option, actionMeta) {
        if (actionMeta.action == "clear") {
            setBrand([]);
        }
        else {
            const temp = [];
            for (let i = 0; i < option.length; i++) {
                temp.push(option[i].value)
            }
            setBrand(temp);
        }
    }
    function handleFamily(option, actionMeta) {
        console.log(option)
        if (actionMeta.action == "clear") {
            setFamily([]);
        }
        else {
            const temp = [];
            for (let i = 0; i < option.length; i++) {
                temp.push(option[i].value)
            }
            setFamily(temp);
        }
    }
    function handleGroup(option, actionMeta) {
        console.log(option)
        if (actionMeta.action == "clear") {
            setGroup([]);
        }
        else {
            const temp = [];
            for (let i = 0; i < option.length; i++) {
                temp.push(option[i].value)
            }
            setGroup(temp);
        }
    }
    function handleAttributes(option, actionMeta) {
        console.log(option)
        if (actionMeta.action == "clear") {
            setAttributes([]);
        }
        else {
            const temp = [];
            for (let i = 0; i < option.length; i++) {
                temp.push(option[i].value)
            }
            setAttributes(temp);
        }
    }
    function handleAttributes2(option, actionMeta) {
        console.log(option)
        if (actionMeta.action == "clear") {
            setAttributes2([]);
        }
        else {
            const temp = [];
            for (let i = 0; i < option.length; i++) {
                temp.push(option[i].value)
            }
            setAttributes2(temp);
        }
    }

    //-----------------------------------------------------------------


    function Filter() {
        var c = [];
        console.log(searchObj.constraints)
        searchObj.constraints && searchObj.constraints.forEach(element => {
            c.push(element)
        });
        if (codeItem !== "") {
            c.push({ fieldName: "code", type: "like", value: codeItem })
        }
        if (nameItem !== "") {
            c.push({ fieldName: "name", type: "like", value: nameItem })
        }
        if (brand.length > 0) {
            c.push({ fieldName: "idBrand", type: "in", value: brand.toString() })
        }
        if (family.length > 0) {
            c.push({ fieldName: "idItemModelFamily", type: "in", value: family.toString() })
        }
        if (group.length > 0) {
            c.push({ fieldName: "idItemModelSalesGroup", type: "in", value: group.toString() })
        }
        if (attributes.length > 0) {
            c.push({ fieldName: "idAttributes", type: "in", value: attributes.toString() })
        }
        if (attributes2.length > 0) {
            c.push({ fieldName: "idAttributes2", type: "in", value: attributes2.toString() })
        }
        if (altezza !== "") {
            c.push({ fieldName: "height", type: "value", value: altezza })
        }
        if (lunghezza !== "") {
            c.push({ fieldName: "length", type: "value", value: lunghezza })
        }
        if (profondità !== "") {
            c.push({ fieldName: "depth", type: "value", value: profondità })
        }


        console.log(c)
        setSearchObj({
            'query': '',
            'fields': searchableFields,
            'constraints': c
        })
    }
    function reset() {
        setNameItem("");
        setCodeItem("");
        setAltezza("");
        setLunghezza("");
        setProfondità("");
        familyRef.current.clearValue();
        brandRef.current.clearValue();
        groupRef.current.clearValue();
        attributesRef.current.clearValue();
        attributes2Ref.current.clearValue();
        setSearchObj({
            'query': '',
            'fields': [],
            'constraints': []
        })
    }



    return (
        <>
            <Container fluid className='mb-2 mt-3'>

                <Accordion defaultActiveKey={['0']} alwaysOpen>
                    <Accordion.Item eventKey="0">
                        <Accordion.Header>Filtri</Accordion.Header>
                        <Accordion.Body>
                            <Row className='align-items-start mb-2'>
                                <Col md={2}>
                                    <Form.Group>
                                        <FormLabel className='label_filters'>Codice articolo</FormLabel>
                                        <Form.Control type="text" onChange={(e) => setCodeItem(e.target.value)} value={codeItem} />
                                    </Form.Group>
                                </Col>
                                <Col md={2}>
                                    <Form.Group>
                                        <FormLabel className='label_filters'>Descrizione articolo</FormLabel>
                                        <Form.Control type="text" onChange={(e) => setNameItem(e.target.value)} value={nameItem} />
                                    </Form.Group>
                                </Col>
                                <Col md={2}>
                                    <Form.Group>
                                        <FormLabel className='label_filters'>Lunghezza imballo (cm)</FormLabel>
                                        <Form.Control type="number" step='0.01' onChange={(e) => setLunghezza(e.target.value)} value={lunghezza} />
                                    </Form.Group>
                                </Col>
                                <Col md={2}>
                                    <Form.Group>
                                        <FormLabel className='label_filters'>Altezza imballo (cm)</FormLabel>
                                        <Form.Control type="number" step='0.01' onChange={(e) => setAltezza(e.target.value)} value={altezza} />
                                    </Form.Group>
                                </Col>
                                <Col md={2}>
                                    <Form.Group>
                                        <FormLabel className='label_filters'>Profondità imballo (cm)</FormLabel>
                                        <Form.Control type="number" step='0.01' onChange={(e) => setProfondità(e.target.value)} value={profondità} />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className='align-items-start mb-2'>
                                <Col md={2}>
                                    <Form.Group>
                                        <FormLabel className='label_filters'>Raggruppamento articolo</FormLabel>
                                        <Select className="basic-multi-select" isMulti onChange={handleFamily} classNamePrefix="select" defaultValue={""}
                                            isClearable={true} isSearchable={true} styles={colourStyles} options={familyList} ref={familyRef} />
                                    </Form.Group>
                                </Col>
                                <Col md={2}>
                                    <Form.Group>
                                        <FormLabel className='label_filters'>Brand</FormLabel>
                                        <Select className="basic-multi-select" isMulti onChange={handleBrand} classNamePrefix="select" defaultValue={""}
                                            isClearable={true} isSearchable={true} styles={colourStyles} options={brandList} ref={brandRef} />
                                    </Form.Group>
                                </Col>
                                <Col md={2}>
                                    <Form.Group>
                                        <FormLabel className='label_filters'>Gruppo vendita</FormLabel>
                                        <Select className="basic-multi-select" isMulti onChange={handleGroup} classNamePrefix="select" defaultValue={""}
                                            isClearable={true} isSearchable={true} styles={colourStyles} options={groupList} ref={groupRef} />
                                    </Form.Group>
                                </Col>
                                <Col md={2}>
                                    <Form.Group>
                                        <FormLabel className='label_filters'>Attributo</FormLabel>
                                        <Select className="basic-multi-select" isMulti onChange={handleAttributes} classNamePrefix="select" defaultValue={""}
                                            isClearable={true} isSearchable={true} styles={colourStyles} options={attributesList} ref={attributesRef} />
                                    </Form.Group>
                                </Col>
                                <Col md={2}>
                                    <Form.Group>
                                        <FormLabel className='label_filters'>Attributo 2</FormLabel>
                                        <Select className="basic-multi-select" isMulti onChange={handleAttributes2} classNamePrefix="select" defaultValue={""}
                                            isClearable={true} isSearchable={true} styles={colourStyles} options={attributesList2} ref={attributes2Ref} />
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Row className='mt-4'>
                                <div className='d-flex'>
                                    <Button variant='primary' className='me-3' onClick={() => Filter()}>Cerca</Button>
                                    <Button variant='outline-danger' onClick={() => reset()}>Reset filtri</Button>
                                </div>
                            </Row>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
            </Container>
        </>
    )
};